import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// Hide console logs in production
if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    const loader = document.getElementById('global-loader');

    if (loader) {
      loader.style.display = 'none';
    }
  })
  .catch((err) => console.error(err));